module.exports = __webpack_public_path__ + "img/run.815122cd.jpg";